module.exports = __webpack_public_path__ + "img/borchia_2.8f22e61f.svg";